import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PopularCuisines.css';
import React, { memo, useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import { ReactComponent as IconChevronDown } from "../../resources/icons/IconChevronDown.svg";
import { isNil, isNotNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink';
var CuisineCard = /*#__PURE__*/memo(function (_ref) {
  var baseHref = _ref.baseHref,
    cuisineName = _ref.cuisineName,
    countOfRestaurants = _ref.countOfRestaurants,
    restaurantsText = _ref.restaurantsText,
    analyticClick = _ref.analyticClick,
    image = _ref.image,
    alt = _ref.alt;
  if (countOfRestaurants <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RouterLink, {
    href: "".concat(baseHref).concat(cuisineName),
    className: "cuisineCard",
    onClick: function onClick() {
      return analyticClick(cuisineName);
    }
  }, isNotNil(image) ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: alt,
    className: "cuisineImage"
  }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "nameCuisines"
  }, cuisineName), /*#__PURE__*/React.createElement("p", {
    className: "restaurantsCount"
  }, countOfRestaurants, " ", restaurantsText)));
});
var PopularCuisines = /*#__PURE__*/memo(function (_ref2) {
  var params = _ref2.params,
    fields = _ref2.fields;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMoreCards = _useState2[0],
    setOpenMoreCards = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    cuisines = _useState4[0],
    setCuisines = _useState4[1];
  var types = "type:Restaurant";
  var algoliaIndexes = get(params, 'SearchIndex');
  var facetName = get(fields, "data.datasource.cuisines.targetItem.fieldNameItem.item.fieldName.value");
  var href = get(fields, "data.datasource.overviewLink.jss.value.href");
  var title = get(fields, "data.datasource.title.jss.value");
  var imagedTagMappings = get(fields, "data.imagedTagMappings.values");
  var tagsToDisplay = get(fields, "data.datasource.cuisines.targetItem.tagsToDisplay.values");
  var moduleDictionary = get(fields, 'data.moduleDictionary');
  var seeLessText = getDictionaryItem(moduleDictionary, 'SeeLess');
  var seeMoreText = getDictionaryItem(moduleDictionary, 'SeeMore');
  var restaurantsText = getDictionaryItem(moduleDictionary, 'Restaurants') || 'restaurants';
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var cuisineAnalyticsButtonClick = function cuisineAnalyticsButtonClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), text);
  };
  var seeMoreAnalyticsButtonClick = function seeMoreAnalyticsButtonClick(textArray) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params), textArray);
  };
  var seeMoreButtonOnClick = function seeMoreButtonOnClick() {
    setOpenMoreCards(function (prev) {
      return !prev;
    });
    seeMoreAnalyticsButtonClick([title, openMoreCards ? seeLessText : seeMoreText]);
  };
  var createOfPopularCuisines = function createOfPopularCuisines() {
    var facetTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var tagImageMappings = {};
    tagsToDisplay.forEach(function (tag) {
      var foundTag = imagedTagMappings.find(function (imagedTag) {
        return imagedTag.cuisine.targetItem.title.value === tag.title.value;
      });
      if (foundTag) {
        var _foundTag$image$jss$v = foundTag.image.jss.value,
          src = _foundTag$image$jss$v.src,
          alt = _foundTag$image$jss$v.alt;
        tagImageMappings[tag.title.value] = {
          image: src ? src : null,
          alt: alt ? alt : null
        };
      } else {
        tagImageMappings[tag.title.value] = {
          image: null,
          alt: null
        };
      }
    });
    var cuisines = tagsToDisplay.reduce(function (acc, cuisine) {
      var cuisineItem = _objectSpread(_objectSpread({
        cuisineName: cuisine.title.value
      }, tagImageMappings[cuisine.title.value]), {}, {
        countOfRestaurants: facetTags[cuisine.title.value]
      });
      if (facetTags[cuisine.title.value]) {
        acc.push(cuisineItem);
      }
      return acc;
    }, []);
    setCuisines(cuisines);
  };
  var algoliaRequest = function algoliaRequest() {
    var itemFilters = {
      facets: [facetName],
      facetFilters: [types, facetName],
      hitsPerPage: 0
    };
    getListing(algoliaIndexes, itemFilters).then(function (response) {
      createOfPopularCuisines(response.facets.tags);
    }).catch(function (error) {
      console.log("error", error);
    });
  };
  React.useEffect(function () {
    algoliaRequest();
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('PopularCuisines component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [PopularCuisines component is empty: please provide data source]");
    }
    return null;
  }
  var showMoreOrLessCuisines = openMoreCards ? cuisines : cuisines.slice(0, 5);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "cuisinesGridContainer"
  }, showMoreOrLessCuisines.map(function (props, index) {
    return /*#__PURE__*/React.createElement(CuisineCard, _extends({
      baseHref: "".concat(href, "?").concat(facetName, "="),
      restaurantsText: restaurantsText,
      analyticClick: cuisineAnalyticsButtonClick
    }, props, {
      key: index
    }));
  }), cuisines.length > 5 ? /*#__PURE__*/React.createElement("button", {
    className: "seeMoreAction ".concat(openMoreCards ? "seeLessBackground" : null),
    onClick: seeMoreButtonOnClick
  }, /*#__PURE__*/React.createElement("p", {
    className: "seeMoreButton"
  }, openMoreCards ? seeLessText : seeMoreText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon ".concat(openMoreCards ? "iconSeeLess" : "iconSeeMore")
  })) : null));
});
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c67ay8h";
var ltrStyles = "l1fyubd6";
var rtlStyles = "ro6h409";
export default PopularCuisines;